<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
    props: {
        glitch: Boolean,
    },
})
export default class GlitchP extends Vue {
    glitch!: boolean;
}
</script>

<template>
    <p class="paragraph" :class="{ 'paragraph--glitch': this.glitch }">
        <slot></slot>
        <span class="paragraph__glitch">
            <template
                v-for="child in this.$slots?.default?.()"
                v-bind:key="child.key"
            >
                <component :is="child" />
            </template>
        </span>
    </p>
</template>

<style scoped>
.paragraph {
    --clip-one: polygon(
        0 2%,
        100% 2%,
        100% 95%,
        95% 95%,
        95% 90%,
        85% 90%,
        85% 95%,
        8% 95%,
        0 70%
    );
    --clip-two: polygon(
        0 78%,
        100% 78%,
        100% 100%,
        95% 100%,
        95% 90%,
        85% 90%,
        85% 100%,
        8% 100%,
        0 78%
    );
    --clip-three: polygon(
        0 44%,
        100% 44%,
        100% 54%,
        95% 54%,
        95% 54%,
        85% 54%,
        85% 54%,
        8% 54%,
        0 54%
    );
    --clip-four: polygon(
        0 0,
        100% 0,
        100% 0,
        95% 0%,
        95% 0,
        85% 0,
        85% 0,
        8% 0,
        0 0
    );
    --clip-five: polygon(
        0 0,
        100% 0,
        100% 0,
        95% 0%,
        95% 0,
        85% 0,
        85% 0,
        8% 0,
        0 0
    );
    --clip-six: polygon(
        0 40%,
        100% 40%,
        100% 85%,
        95% 85%,
        95% 85%,
        85% 85%,
        85% 85%,
        8% 85%,
        0 70%
    );
    --clip-seven: polygon(
        0 63%,
        100% 63%,
        100% 80%,
        95% 80%,
        95% 80%,
        85% 80%,
        85% 80%,
        8% 80%,
        0 70%
    );
    --border: 2px;
    --shimmy-distance: 2;

    position: relative;
    overflow: hidden;
    transition: color 0.1s;
}

.paragraph__glitch {
    position: absolute;
    top: calc(var(--border) * -1);
    left: calc(var(--border) * -1);
    right: calc(var(--border) * -1);
    bottom: calc(var(--border) * -1);
    text-shadow: 2px 2px 5px var(--amber-gold-complimentary),
        -2px -2px 10px var(--amber-gold-complimentary);
    animation: glitch 2s infinite;
    display: none;
}

.paragraph.paragraph--glitch {
    color: rgba(var(--amber-gold), 0.5);
}
.paragraph.paragraph--glitch .paragraph__glitch {
    color: rgba(var(--amber-gold), 1);
    display: block;
}

@keyframes glitch {
    0% {
        clip-path: var(--clip-one);
    }
    2%,
    8% {
        clip-path: var(--clip-two);
        transform: translate(calc(var(--shimmy-distance) * -1%), 0);
    }
    6% {
        clip-path: var(--clip-two);
        transform: translate(calc(var(--shimmy-distance) * 1%), 0);
    }
    9% {
        clip-path: var(--clip-two);
        transform: translate(0, 0);
    }
    10% {
        clip-path: var(--clip-three);
        transform: translate(calc(var(--shimmy-distance) * 1%), 0);
    }
    13% {
        clip-path: var(--clip-three);
        transform: translate(0, 0);
    }
    14%,
    21% {
        clip-path: var(--clip-four);
        transform: translate(calc(var(--shimmy-distance) * 1%), 0);
    }
    25% {
        clip-path: var(--clip-five);
        transform: translate(calc(var(--shimmy-distance) * 1%), 0);
    }
    30% {
        clip-path: var(--clip-five);
        transform: translate(calc(var(--shimmy-distance) * -1%), 0);
    }
    35%,
    45% {
        clip-path: var(--clip-six);
        transform: translate(calc(var(--shimmy-distance) * -1%));
    }
    40% {
        clip-path: var(--clip-six);
        transform: translate(calc(var(--shimmy-distance) * 1%));
    }
    50% {
        clip-path: var(--clip-six);
        transform: translate(0, 0);
    }
    55% {
        clip-path: var(--clip-seven);
        transform: translate(calc(var(--shimmy-distance) * 1%), 0);
    }
    60% {
        clip-path: var(--clip-seven);
        transform: translate(0, 0);
    }
    31%,
    61%,
    100% {
        clip-path: var(--clip-four);
    }
}
</style>
